import { render, staticRenderFns } from "./OrderInfoModal.vue?vue&type=template&id=749618d7&scoped=true&"
import script from "./OrderInfoModal.vue?vue&type=script&lang=js&"
export * from "./OrderInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749618d7",
  null
  
)

export default component.exports